/**
 * Takes a string and returns the string formatted as a phone number
 * @param {string} inputString
 * @returns {string}
 *
 * @example
 *
 * formatPhoneNumber(5555555555)
 * returns the following 555-555-5555
 *
 * formatPhoneNumber(+15109211432)
 * returns the following 510-921-1432
 */

function formatPhoneNumber(inputString) {
	if (inputString === '') return '';

	// Remove all non-digit characters except the + symbol
	let cleanString = inputString.replace(/[^\d+]/g, '');

	// Handle country codes: only remove if it results in a valid phone number
	// Common patterns: +1 followed by 10 digits (US/Canada), +44 followed by 10-11 digits (UK), etc.
	if (cleanString.startsWith('+1') && cleanString.length === 12) {
		// +1 followed by 10 digits (US/Canada format)
		cleanString = cleanString.substring(2);
	} else if (
		cleanString.startsWith('+44') &&
		(cleanString.length === 13 || cleanString.length === 14)
	) {
		// +44 followed by 10-11 digits (UK format)
		cleanString = cleanString.substring(3);
	} else if (cleanString.startsWith('+61') && cleanString.length === 12) {
		// +61 followed by 9 digits (Australia format)
		cleanString = cleanString.substring(3);
	} else if (cleanString.startsWith('+') && cleanString.length > 10) {
		// Generic: if it starts with + and is longer than 10 digits, try to remove country code
		// This is a fallback for other country codes
		const withoutPlus = cleanString.substring(1);
		if (withoutPlus.length >= 10) {
			cleanString = withoutPlus;
		}
	}

	// Remove any remaining + symbols
	cleanString = cleanString.replace(/\+/g, '');

	if (cleanString.length > 6) {
		const firstThreeDigits = cleanString.slice(0, 3);
		const fourthAndFifthDigits = cleanString.slice(3, 6);
		const restOfDigits = cleanString.slice(6);

		return `${firstThreeDigits}-${fourthAndFifthDigits}-${restOfDigits}`;
	}

	if (cleanString.length > 3) {
		// get the first 3 digits
		const firstThreeDigits = cleanString.slice(0, 3);
		const restOfDigits = cleanString.slice(3);
		return `${firstThreeDigits}-${restOfDigits}`;
	}

	return cleanString;
}

export default formatPhoneNumber;
